const Main = () => import('./Main.vue')

export default [{
  path: 'apresentacao-lotes/:id',
  name: 'apresentacao-lotes',
  component: Main
}
]



// WEBPACK FOOTER //
// ./src/app/website/apresentacao-lotes/routes.js